<template>
  <form ref="form" class="needs-validation" @submit.prevent="save">
    <div class="row">
      <div v-if="title" class="col-sm-12 my-3">
        <h3>{{ title }}</h3>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label"> Artículo </label>

          <el-select
            v-validate="modelValidations.article"
            :value="selectedArticleText"
            name="article"
            autocomplete="off"
            placeholder="Artículo"
            filterable
            @change="setArticle"
          >
            <el-option v-for="option in articlesOptions" :key="option.value" :label="option.label" :value="option">
              <div class="article-option">
                <span>{{ option.label }}</span>
                <span>({{ quantityOption(option) }})</span>
              </div>
            </el-option>
          </el-select>

          <small v-show="quantity.invalid" class="text-danger">
            {{ getError('article') }}
          </small>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label"> Cantidad </label>

          <el-input
            v-model="formData.quantity"
            v-validate="modelValidations.quantity"
            name="quantity"
            pattern="[0-9]+"
            placeholder="Cantidad"
            suffix-icon="fas fa-boxes"
            type="number"
            :disabled="!hasArticles"
          >
          </el-input>

          <small v-if="checkStock" class="text-danger"> No hay suficientes articulos disponibles </small>

          <small v-if="checkZero" class="text-danger"> La cantidad no puede ser cero </small>

          <small v-show="quantity.invalid" class="text-danger">
            {{ getError('quantity') }}
          </small>
        </div>
      </div>

      <div class="col-sm-2 pt-4">
        <base-button
          class="rounded-pill mt-2"
          native-type="submit"
          size="sm"
          type="success"
          :disabled="checkStock || checkZero"
        >
          <i class="fas fa-plus-circle mr-1"></i><span>Agregar</span>
        </base-button>
      </div>
    </div>
    <div v-if="!hasArticles" class="row">
      <div class="col">
        <p class="font-italic text-danger">Asegúrese de tener artículos cargados para la variedad asociada</p>
      </div>
    </div>
  </form>
</template>

<script>
import { Select, Option } from 'element-ui';
import { mapFields } from 'vee-validate';
import { LOAD_DISTRIBUTOR, ADJUST } from '@/util/constants/deliveryNotes';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    title: {
      type: String,
      default: 'Agregar Artículos',
    },

    campaign: {
      type: Object,
      default: null,
    },

    distributorTo: {
      type: Object,
      default: null,
    },

    distributorFrom: {
      type: Object,
      default: null,
    },

    deliveryNoteType: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      articles: [],
      validated: false,

      formData: {
        article: null,
        quantity: null,
      },

      modelValidations: {
        article: {
          required: true,
        },

        quantity: {
          required: true,
          integer: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['article', 'quantity']),

    articlesOptions() {
      return this.$selectOptions(this.articles, { sort: true, label: 'description' });
    },

    selectedArticleText() {
      const article = this.formData.article;

      if (!article) {
        return null;
      }

      if (this.deliveryNoteType === LOAD_DISTRIBUTOR) {
        return `${article.description} (${article.availability})`;
      }

      return `${article.description} (${article.distributorStock})`;
    },

    hasArticles() {
      return this.articles.length > 0;
    },

    quantityOption() {
      return (option) => {
        const article = this.articles.find((article) => article.id === option.value);

        if (!article) {
          return '';
        }

        if (this.deliveryNoteType === LOAD_DISTRIBUTOR) {
          return article.availability;
        }

        return article.distributorStock;
      };
    },

    checkZero() {
      return this.formData.article ? this.formData.quantity == 0 : false;
    },

    checkStock() {
      if (this.deliveryNoteType === LOAD_DISTRIBUTOR) {
        return false;
      }

      if (this.deliveryNoteType === ADJUST) {
        return this.formData.article
          ? parseInt(this.formData.quantity) > parseInt(this.formData.article.distributorStock)
          : false;
      }

      return this.formData.article ? parseInt(this.formData.quantity) > parseInt(this.formData.article.stock) : false;
    },

    getDistributor() {
      return this.deliveryNoteType === ADJUST ? this.distributorTo : this.distributorFrom;
    },
  },

  created() {
    this.fetchArticles();
  },

  methods: {
    setArticle(article) {
      this.formData.article = this.articles.find(({ id }) => id === article.value);
    },

    fetchArticles() {
      this.$services
        .resource('articles')
        .get(this.getParams())
        .then((res) => res.data.data)
        .then((data) => (this.articles = data.articles));
    },

    getParams() {
      return {
        'filter[campaign]': this.campaign ? this.campaign.id : null,
        'filter[distributor]': this.getDistributor ? this.getDistributor.id : null,
        'filter[articles_for_sale]': true,
      };
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((valid) => {
        if (valid) {
          let newItem = {
            article: this.formData.article,
            quantity: this.formData.quantity,
          };
          this.$emit('addItem', newItem);
        }
      });
    },

    clean() {
      this.formData.article = null;
      this.formData.quantity = null;
      this.validated = false;
      this.errors.clear();
      this.$validator.reset();
    },

    reset() {
      this.$refs.form.reset();
      this.clean();
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
::v-deep .article-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
